import React, { useState, useCallback, useEffect } from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import sage from "../../../images/splash/sage.jpeg";
import { Nav } from "react-bootstrap";
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import FullCalendar from '@fullcalendar/react'; // Import FullCalendar
import dayGridPlugin from '@fullcalendar/daygrid'; // Import the day grid plugin
import timeGridPlugin from '@fullcalendar/timegrid'; // Import the time grid plugin
import interactionPlugin from '@fullcalendar/interaction'; // Import the interaction plugin
import './roomSeatStatus.css';
import { TabContent, TabPane,  NavItem, NavLink ,Input} from 'reactstrap';
import classnames from 'classnames';
import rooms1 from "../../../images/sb-images/r1.jpeg";
import rooms2 from "../../../images/sb-images/r2.jpeg";
import seats1 from "../../../images/sb-images/s1.jpeg";
import seats2 from "../../../images/sb-images/s2.jpeg";
import Modal from 'react-bootstrap/Modal';
import fruit from "../../../images/sb-images/fruit.webp";
import sign from "../../../images/sb-images/sage sig.webp";
import axios from 'axios';
import { var_api } from "../../constant";
import Loader from "../Loader";
import { Link, useHistory } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';


const RoomSeatStatus = () => {
    const [events, setEvents] = useState([
        { title: 'Event 1', date: '2023-05-01' },
        { title: 'Event 2', date: '2023-05-02' }
      ]); 
      const [activeTab, setActiveTab] = useState('1');
      const [isOpen, setIsOpen] = useState(false);
      const [isdelete, setIsDelete] = useState(false);
      const [rooms, setRooms] = useState([]);
      const [seats, setSeats] = useState([]);
      const [isOrderConfirmation, setIsOrderConfirmation] = useState(false);
      const [viewService, setViewService] = useState(null);
      const [selectedRoomName, setSelectedRoomName] = useState('');
      const [isOrderConfirmationseat, setIsOrderConfirmationseat] = useState(false);
      const [viewServiceseat, setViewServiceseat] = useState(null);
      const [selectedRoomNameseat, setSelectedRoomNameseat] = useState('')
      const [deletedOrder, setDeletedOrder] = useState(null);
      const [checkedServices, setCheckedServices] = useState([]);
      const [allChecked, setAllChecked] = useState(false);
      const [remarks, setRemarks] = useState('');
      const [startDate, setStartDate] = useState('');
      const [selectedDate, setSelectedDate] = useState(' ');
      const [isLoader, setIsLoader] = useState(false);
      const [isOpenOrderEdit, setIsOpenOrderEdit] = useState(false);
      const [updateOrder, setUpdateOrder] = useState(null);
      const [beauticians, setBeauticians] = useState([]);
      const [additionalCheckedUpdate, setAdditionalCheckedUpdate] = useState(false);
      const [additionalCostUpdate,setAdditionalCostUpdate] =  useState(0);
      const [additionalDurationUpdate, setAdditionalDurationUpdate] = useState(0);
      const history = useHistory();

      const timeSlots = [ '07:00 AM','08:00 AM', '09:00 AM','10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM', '06:00 PM', '07:00 PM', '08:00 PM'];
      // const rooms = [
      //     { id: 1, name: 'Room 1', description: 'Description for Room 1', image: rooms1, details:[
      //       {
      //         name:"Jennie",
      //         status:"Completed",
      //         color:"green"
      //       }
      //     ] },
      //     { id: 2, name: 'Room 2', description: 'Description for Room 2', image: rooms2, details:[
            
      //       {
      //         name:"zoya",
      //         status:"Upcoming",
      //         color:"blue"
      //       }
      //     ]  },
      //     { id: 3, name: 'Room 3', description: 'Description for Room 3', image: rooms1, details:[
           
      //       {
      //         name:"vidhya",
      //         status:"Book Now",
      //         color:"red"
      //       }
      //     ]  }
      //   ];
      //   const seats = [
      //     { id: 1, name: 'seat 1', description: 'Description for seat 1', image: seats1 },
      //     { id: 2, name: 'seat 2', description: 'Description for seat 2', image: seats2 },
      //     { id: 3, name: 'seat 3', description: 'Description for seat 3', image: seats1 }
      //   ];

      const toggleTab = tab => {
          if (activeTab !== tab) setActiveTab(tab);
        }
  
    
      const handleDateClick = useCallback((arg) => {
        // alert('Date clicked: ' + arg.dateStr);
        const date = new Date(arg.dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        setSelectedDate(formattedDate);
        console.log("clicked date",formattedDate);
        fetchRoomData(formattedDate);
        fetchSeatData(formattedDate);
      }, []);
    
      const handleEventClick = useCallback((info) => {
        alert('Event: ' + info.event.title);
        alert('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
        alert('View: ' + info.view.type);
      }, []);
    
      // const handleSelect = useCallback((arg) => {
      //   alert('selected ' + arg.startStr + ' to ' + arg.endStr);
      // }, []);

      const handleCloseOrderDeleteConfirmation = () => {
        setIsOpen(false);
      }

      const handleOPenOrderConfirmation = () => {
        setIsOpen(true);
      }

      const handleCloseDelete = () => {
        setIsDelete(false);
      }

      const handleOpenDelete = (order) => {
        setIsDelete(true);
        setDeletedOrder(order)
        console.log("deleted order",order)
      }


      //onchange function for from_time when the put
const handleTimeChangeUpdateRoom = async (event) => {
  const { name, value } = event.target;
  const service_duration  = updateOrder.service_duration;
  const updatedOrderCopy = { ...updateOrder, [name]: value };

  if (name === 'room_start_time') {
    // Extract hours, minutes, and seconds from the start_time
    const [startHours, startMinutes, startSeconds] = value.split(':').map(Number);

    // Calculate the total duration in minutes and seconds
    const durationHours = Math.floor(service_duration / 60);
    const durationMinutes = service_duration % 60;

    // Calculate the new time by adding duration to start time
    let endHours = startHours + durationHours;
    let endMinutes = startMinutes + durationMinutes;
    let endSeconds = startSeconds || 0;

    // Handle overflow of minutes to hours
    if (endMinutes >= 60) {
      endHours += Math.floor(endMinutes / 60);
      endMinutes = endMinutes % 60;
    }

   // Handle seconds correctly
   endSeconds = (startSeconds || 0).toString().padStart(2, '0');

   // Format end time to ensure two digits for hours, minutes, and seconds
   const formattedEndHours = endHours.toString().padStart(2, '0');
   const formattedEndMinutes = endMinutes.toString().padStart(2, '0');

    // Set the end_time in updatedOrder
    updatedOrderCopy.room_end_time = `${formattedEndHours}:${formattedEndMinutes}:${endSeconds}`;
  }

  setUpdateOrder(updatedOrderCopy)
  

     // Call fetchSeatCheckingUpdate to check seat availability
  await fetchRoomCheckingUpdate(updatedOrderCopy.room_start_time, updatedOrderCopy.room_end_time, updatedOrderCopy.room_id, updatedOrderCopy.room_service_orders_id);

  
}



 //onchange function for from_time when the put
 const handleTimeChangeUpdateSeat = async (event) => {
  const { name, value } = event.target;
  const service_duration  = updateOrder.service_duration;
  const updatedOrderCopy = { ...updateOrder, [name]: value };

  if (name === 'seat_start_time') {
    // Extract hours, minutes, and seconds from the start_time
    const [startHours, startMinutes, startSeconds] = value.split(':').map(Number);

    // Calculate the total duration in minutes and seconds
    const durationHours = Math.floor(service_duration / 60);
    const durationMinutes = service_duration % 60;

    // Calculate the new time by adding duration to start time
    let endHours = startHours + durationHours;
    let endMinutes = startMinutes + durationMinutes;
    let endSeconds = startSeconds || 0;

    // Handle overflow of minutes to hours
    if (endMinutes >= 60) {
      endHours += Math.floor(endMinutes / 60);
      endMinutes = endMinutes % 60;
    }

   // Handle seconds correctly
   endSeconds = (startSeconds || 0).toString().padStart(2, '0');

   // Format end time to ensure two digits for hours, minutes, and seconds
   const formattedEndHours = endHours.toString().padStart(2, '0');
   const formattedEndMinutes = endMinutes.toString().padStart(2, '0');

    // Set the end_time in updatedOrder
    updatedOrderCopy.seat_end_time = `${formattedEndHours}:${formattedEndMinutes}:${endSeconds}`;
  }

  setUpdateOrder(updatedOrderCopy)
  
    // Call fetchSeatCheckingUpdate to check seat availability
  await fetchSeatCheckingUpdate(updatedOrderCopy.seat_start_time, updatedOrderCopy.seat_end_time, updatedOrderCopy.seat_id, updatedOrderCopy.seat_service_orders_id);
 
}


//seat chekcing while put
const fetchSeatCheckingUpdate = async (fromTime, toTime, seatId, id) => {
  const token = localStorage.getItem('token');

  const headers = {
    Authorization: token,
  };

  try {
    const response = await axios.get(`${var_api}/api/checking-seat-free-put/${fromTime}/${toTime}/${seatId}/${selectedDate}/${id}`, { headers });
    const data = response.data;
    console.log('Fetching data:', data);

    if (!data.isFree) {
      alert(`This seat is already in use from ${fromTime} to ${toTime}`);
      // Clear the entered from_time
      const updatedOrderCopy = { ...updateOrder };
      updatedOrderCopy.start_time = ''; // Reset start_time
      setUpdateOrder(updatedOrderCopy)
    }
  } catch (error) {
    console.log('Error fetching data:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
  }
  }
}


  const fetchRoomCheckingUpdate = async (fromTime, toTime, roomId, id) => {
  const token = localStorage.getItem('token');

  const headers = {
    Authorization: token,
  };

  try {
    const response = await axios.get(`${var_api}/api/checking-room-free-put/${fromTime}/${toTime}/${roomId}/${selectedDate}/${id}`, { headers });
    const data = response.data;
    console.log('Fetching data:', data);

    if (!data.isFree) {
      alert(`This room is already in use from ${fromTime} to ${toTime}`);
      // Clear the entered from_time
      const updatedOrderCopy = { ...updateOrder };
      updatedOrderCopy.start_time = ''; // Reset start_time
      setUpdateOrder(updatedOrderCopy);
    }
  } catch (error) {
    console.log('Error fetching data:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
  }
  }
  
}


//onchange function for beautician when the put
 const handleBeauticianChangeUpdate = (selectedOption) => {
  console.log('Selected beautician:', selectedOption);
  const updatedOrder = {
    ...updateOrder,
    employee_id: selectedOption.value,
    employee_name: selectedOption.label,
  };
  setUpdateOrder(updatedOrder,()=>{
    console.log('Updated order:', updateOrder);
  })
};


const fetchBeauticians = async()=> {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `${token}`,
};
    try {
      const response = await axios.get(`${var_api}/api/employee/get-active-employees`, { headers });
      const data = response.data;
      console.log(' fetching data:', data);
      const beauticians = data.map(beautician => ({
        value: beautician.id,
        label: beautician.name
      }));
      setBeauticians(beauticians);
      
    } catch (error) {
      console.log('Error fetching data:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
    }
      
    }
}

      //open the update modal for time and beautician
      const handleOpenOrderEdit = (order) => {
        setIsOpenOrderEdit(true);
        setUpdateOrder(order);
        setAdditionalCostUpdate(order.additional_cost);
        setAdditionalDurationUpdate(order.additional_duration);
        console.log('updated order', order,updateOrder)
      }

      //close the update modal for time and beautician
      const handleCloseOrderEdit = () => {
        setIsOpenOrderEdit(false);
      }


      const handleOpenEyeOrderDetail = (order, roomName) => {
        setIsOrderConfirmation(true);
        setViewService(order);
        setSelectedRoomName(roomName);
        console.log("view order", order);
      };

      const handleCloseOrderConfirmation = () => {
        setIsOrderConfirmation(false);
        setViewService(null);
        setSelectedRoomName('');
      };

      const handleOpenEyeOrderDetailseat = (order, seat_name) => {
        setViewServiceseat(order);
        setSelectedRoomNameseat(seat_name);
        setIsOrderConfirmationseat(true);
        console.log("view order", order);
      };
    
      const handleCloseOrderConfirmationseat = () => {
        setIsOrderConfirmationseat(false);
        setViewServiceseat(null);
        setSelectedRoomNameseat('');
      };

      useEffect(() => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = today.getFullYear();
        const formattedDate = `${day}-${month}-${year}`; // Formatting today's date as dd-MM-yyyy
        fetchRoomData(formattedDate);
        fetchSeatData(formattedDate);
        setSelectedDate(formattedDate);
        fetchBeauticians();
    }, []);


    // Function to convert minutes to hours and minutes
const convertMinutesToHours = (minutes) => {
  if (!minutes && minutes == 0) return "0h 0m"; 
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours > 0) {
    return `${hours} hrs ${remainingMinutes} mins`;
  } else {
    return `${remainingMinutes} mins`;
  }
};


    const fetchRoomData = async (date) => {
      setIsLoader(true);
      const token = localStorage.getItem('token'); 
      const config = {
          headers: { Authorization: `${token}` }
      };
      console.log("selected api date", date)
      // const formattedDate = todayDateInput.split('-').reverse().join('-');
      try {
        const response = await axios.get(`${var_api}/api/room-status/get/${date}`, config);
          // const response = await axios.get(`${var_api}/api/room-status/get/${formattedDate}`, config);
          const data = response.data;
          if (Array.isArray(data)) {
              setRooms(data);
          } else {
              console.error('API response is not an array:', data);
              setRooms([]);
          }
      } catch (error) {
          console.log(error);
          if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
      }
      finally{
        setIsLoader(false);
      }
  };

  const fetchSeatData = async (date) => {
    setIsLoader(true);
      const token = localStorage.getItem('token'); 
      const config = {
          headers: { Authorization: `${token}` }
      };
      // const formattedDate = todayDateInput.split('-').reverse().join('-');
      console.log("slected api date", date)
      try {
          const response = await axios.get(`${var_api}/api/seat-status/get/${date}`, config);
          // const response = await axios.get(`${var_api}/api/seat-status/get/${formattedDate}`, config);
          const data = response.data;
          if (Array.isArray(data)) {
              setSeats(data);
          } else {
              console.error('API response is not an array:', data);
              setSeats([]);
          }
      } catch (error) {
          console.log(error);
          if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
      }finally{
        setIsLoader(false);
      }
  };


  useEffect(() => {
    if (deletedOrder && deletedOrder.services) {
      if (allChecked) {
        const allServiceIds = deletedOrder.services.map((service, index) => index);
        setCheckedServices(allServiceIds);
      } else {
        setCheckedServices([]);
      }
    }
  }, [allChecked, deletedOrder]);

  const handleServiceCheck = (index) => {
    setCheckedServices((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const handleAllCheck = () => {
    setAllChecked(!allChecked);
  };


  //put method for time and beauticain for seat
const handleSubmitUpdate = async () => {
  console.log('before put', updateOrder);
  setIsLoader(true);
  const serviceId = updateOrder.seat_service_orders_id; // Use the appropriate ID
  const token = localStorage.getItem('token');
  const data = {
    seat_start_time: updateOrder.seat_start_time,
    seat_end_time: updateOrder.seat_end_time,
    employee_id: updateOrder.employee_id,
    employee_name: updateOrder.employee_name,
    service_cost:   updateOrder.service_cost,
    // service_duration: additionalCheckedUpdate ? parseInt(updateOrder. service_duration) + parseInt(additionalDurationUpdate) : updateOrder. service_duration,
    service_duration: updateOrder. service_duration,
    additional_cost: additionalCostUpdate,
    additional_duration: additionalDurationUpdate
  };

  try {
    const response = await axios.put(`${var_api}/api/seat_service/put/${serviceId}`, data, {
      headers: {
        Authorization: token
      }
    });
    fetchSeatData(selectedDate)
    setIsOpenOrderEdit(false);
    setIsOrderConfirmationseat(false);
    setIsOrderConfirmation(false);
    console.log('Service order updated successfully', response.data);
  } catch (error) {
    console.error('Error updating service order:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
  }
  }finally{
    setIsLoader(false);
  }
};


//put method for time and beauticain for room
const handleSubmitUpdateroom = async () => {
  console.log('before put', updateOrder);
  setIsLoader(true);
  const serviceId = updateOrder.room_service_orders_id; // Use the appropriate ID
  const token = localStorage.getItem('token');
  const data = {
    room_start_time: updateOrder.room_start_time,
    room_end_time: updateOrder.room_end_time,
    employee_id: updateOrder.employee_id,
    employee_name: updateOrder.employee_name,
    // service_cost:  additionalCheckedUpdate ? updateOrder.service_cost + additionalCostUpdate : updateOrder.service_cost,
    service_cost: updateOrder.service_cost,
    service_duration:  updateOrder. service_duration,
    additional_cost: additionalCostUpdate,
    additional_duration: additionalDurationUpdate
  };

  try {
    const response = await axios.put(`${var_api}/api/room_service/put/${serviceId}`, data, {
      headers: {
        Authorization: token
      }
    });
    fetchRoomData(selectedDate);
    setIsOpenOrderEdit(false);
    setIsOrderConfirmation(false);
    setIsOrderConfirmationseat(false);
    console.log('Service order updated successfully', response.data);
  } catch (error) {
    console.error('Error updating service order:', error);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
  }
  }finally{
    setIsLoader(false);
  }
};



  // const handleSubmit = async () => {
  //   setIsLoader(true);
  //   if (checkedServices.length === 0) {
  //     alert('Please select at least one service.');
  //     return;
  //   }
  //   console.log("sd",checkedServices,deletedOrder)
  //   const selectedServices = deletedOrder.services.filter((service, index) =>
  //     checkedServices.includes(index)
  //   );


  //   console.log("sd",selectedServices)

  //   const token = localStorage.getItem('token');

  //   try {
  //     for (const service of selectedServices) {
  //       const postData = {
  //         order_id: deletedOrder.order_id,
  //         customer_name: deletedOrder.customer_name,
  //         customer_mobile: deletedOrder.customer_mobile,
  //         date: deletedOrder.order_date,
  //         employee_name: service.employee_name,
  //         employee_id: service.employee_id,
  //         service_name: service.service_name,
  //         service_id: service.service_id,
  //         remarks: remarks,
  //       };
  
  //       const response = await axios.post(`${var_api}/api/cancellation-history/post`, postData, {
  //         headers: {
  //           Authorization: `${token}`, // Add your token here
  //         },
  //       });
        
  //       console.log(response.data);

  //        // After successfully posting, call the delete API
  //     const deleteResponse = await axios.delete(`${var_api}/api/seat-services/delete/${service.seat_service_orders_id}`, {
  //       headers: {
  //         Authorization: `${token}`, // Add your token here
  //       },
  //     });

  //     console.log("Delete response:", deleteResponse.data);
  //     }
  //     alert('Cancellation successful');
  //     setIsDelete(false);
  //     setRemarks(' ');
  //     fetchSeatData(selectedDate);
  //   } catch (error) {
  //     console.error('Error posting cancellation:', error);
  //     alert('Error posting cancellation');
  //   }finally{
  //     setIsLoader(false);
  //   }
  // };



  // const handleSubmitRoom = async () => {
  //   if (checkedServices.length === 0) {
  //     alert('Please select at least one service.');
  //     return;
  //   }
  //   console.log("sd",checkedServices,deletedOrder)
  //   const selectedServices = deletedOrder.services.filter((service, index) =>
  //     checkedServices.includes(index)
  //   );


  //   console.log("sd",selectedServices)

  //   const token = localStorage.getItem('token');

  //   try {
  //     for (const service of selectedServices) {
  //       const postData = {
  //         order_id: deletedOrder.order_id,
  //         customer_name: deletedOrder.customer_name,
  //         customer_mobile: deletedOrder.customer_mobile,
  //         date: deletedOrder.order_date,
  //         employee_name: service.employee_name,
  //         employee_id: service.employee_id,
  //         service_name: service.service_name,
  //         service_id: service.service_id,
  //         remarks: remarks,
  //       };
  
  //       const response = await axios.post(`${var_api}/api/cancellation-history/post`, postData, {
  //         headers: {
  //           Authorization: `${token}`, // Add your token here
  //         },
  //       });
        
  //       console.log(response.data);

  //        // After successfully posting, call the delete API
  //     const deleteResponse = await axios.delete(`${var_api}/api/room-services/delete/${service.room_service_orders_id}`, {
  //       headers: {
  //         Authorization: `${token}`, // Add your token here
  //       },
  //     });

  //     console.log("Delete response:", deleteResponse.data);
  //     }
  //     alert('Cancellation successful');
  //     setIsDelete(false);
  //     setRemarks(' ');
  //     fetchRoomData(selectedDate);
  //   } catch (error) {
  //     console.error('Error posting cancellation:', error);
  //     alert('Error posting cancellation');
  //   }
  // };


  const handleSubmitRoom = async () => {
    setIsLoader(true);

    const token = localStorage.getItem('token');

    try {
        const postData = {
          order_id: viewService.order_id,
          customer_name: viewService.customer_name,
          customer_mobile: viewService.customer_mobile,
          date: viewService.order_date,
          employee_name: deletedOrder.employee_name,
          employee_id: deletedOrder.employee_id,
          service_name: deletedOrder.service_name,
          service_id: deletedOrder.service_id,
          remarks: remarks,
        };
  
        const response = await axios.post(`${var_api}/api/cancellation-history/post`, postData, {
          headers: {
            Authorization: `${token}`, // Add your token here
          },
        });
        
        console.log(response.data);

         // After successfully posting, call the delete API
      const deleteResponse = await axios.delete(`${var_api}/api/room-services/delete/${deletedOrder.room_service_orders_id}`, {
        headers: {
          Authorization: `${token}`, // Add your token here
        },
      });

      console.log("Delete response:", deleteResponse.data);
      
      alert('Cancellation successful');
      setIsDelete(false);
      setIsOrderConfirmation(false);
      setRemarks(' ');
      fetchRoomData(selectedDate);
    } catch (error) {
      console.error('Error posting cancellation:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
    }
      alert('Error posting cancellation');
    }
  };



  const handleSubmit = async () => {
    setIsLoader(true);
    
    const token = localStorage.getItem('token');

    try {
    
        const postData = {
          order_id: viewServiceseat.order_id,
          customer_name: viewServiceseat.customer_name,
          customer_mobile: viewServiceseat.customer_mobile,
          date: viewServiceseat.order_date,
          employee_name: deletedOrder.employee_name,
          employee_id: deletedOrder.employee_id,
          service_name: deletedOrder.service_name,
          service_id: deletedOrder.service_id,
          remarks: remarks,
        };
  
        const response = await axios.post(`${var_api}/api/cancellation-history/post`, postData, {
          headers: {
            Authorization: `${token}`, // Add your token here
          },
        });
        
        console.log(response.data);

         // After successfully posting, call the delete API
      const deleteResponse = await axios.delete(`${var_api}/api/seat-services/delete/${deletedOrder.seat_service_orders_id}`, {
        headers: {
          Authorization: `${token}`, // Add your token here
        },
      });

      console.log("Delete response:", deleteResponse.data);
      
      alert('Cancellation successful');
      setIsDelete(false);
      setIsOrderConfirmationseat(false);
      setRemarks(' ');
      fetchSeatData(selectedDate);
    } catch (error) {
      console.error('Error posting cancellation:', error);
      alert('Error posting cancellation');
      if (error.response && error.response.status === 401) {
        history.push('/signin');
    }
    }finally{
      setIsLoader(false);
    }
  };

    //go to home
 const handleGoToHome = () => {
  history.push('/sb-home');
}

//onchange function for check box
const handleAdditionalCheckboxChangeUpdate = (event) => {
  const isChecked = event.target.checked;
  setAdditionalCheckedUpdate(isChecked);
  // setAdditionalCostUpdate(0);
  // setAdditionalDurationUpdate(0);
};


const handleAdditionalCostChangeUpdate = (event) => {
  const value = event.target.value;
  setAdditionalCostUpdate(value.trim() === '' ? 0 : parseFloat(value));
};

const recalculateEndTime = (order, additionalDuration) => {
  const totalDuration = parseInt(order&& order.service_duration, 10) + parseInt(additionalDuration, 10);
  if (order && order.room_start_time) {
    const [startHours, startMinutes, startSeconds] = order.room_start_time.split(':').map(Number);

    const durationHours = Math.floor(totalDuration / 60);
    const durationMinutes = totalDuration % 60;

    let endHours = startHours + durationHours;
    let endMinutes = startMinutes + durationMinutes;
    let endSeconds = startSeconds || 0;

    if (endMinutes >= 60) {
      endHours += Math.floor(endMinutes / 60);
      endMinutes = endMinutes % 60;
    }

    endSeconds = endSeconds.toString().padStart(2, '0');

    const formattedEndHours = endHours.toString().padStart(2, '0');
    const formattedEndMinutes = endMinutes.toString().padStart(2, '0');

    const updatedOrderCopy = {
      ...order,
      room_end_time: `${formattedEndHours}:${formattedEndMinutes}:${endSeconds}`,
    };

    setUpdateOrder(updatedOrderCopy);
  }
};


useEffect(() => {
  recalculateEndTime(updateOrder, additionalDurationUpdate);
}, [additionalDurationUpdate, updateOrder&& updateOrder.room_start_time]);

const totalDuration = parseInt(updateOrder&& updateOrder.service_duration, 10) + parseInt(additionalDurationUpdate, 10);
const totalCost = additionalCheckedUpdate
  ? updateOrder&& updateOrder.service_cost + additionalCostUpdate
  : updateOrder&&updateOrder.service_cost;

const handleAdditionalDurationChangeUpdate = (event) => {
  const value = event.target.value;
  const additionalDuration = value.trim() === '' ? 0 : parseInt(value);
  setAdditionalDurationUpdate(additionalDuration);
  recalculateEndTime(updateOrder, additionalDuration);
};

function formatTimeTo12Hours(timeString) {
  if (!timeString) return '';
  const [hours, minutes] = timeString.split(':');
  let period = 'AM';
  let hour = parseInt(hours, 10);

  if (hour === 0) {
    hour = 12;
  } else if (hour === 12) {
    period = 'PM';
  } else if (hour > 12) {
    hour -= 12;
    period = 'PM';
  }

  return `${hour}:${minutes} ${period}`;
}


    
    return(
        <>
        {isLoader && <Loader/>}
<Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       ROOM & SEAT STATUS
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link onClick={handleGoToHome} style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>

<div style={{margin:"auto",padding:"10px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={3}>
  <Card style={{ border: "none", maxWidth:"23rem", padding:"15px 10px", margin:"auto", height:"auto", borderRadius:"20px", boxShadow:"rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
    {/* <Card.Header>Create Employee</Card.Header> */}
    <Card.Body>
    <FullCalendar
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      headerToolbar={{
        left: 'prev,next',
        center: 'title',
        right: 'dayGridMonth'
      }}
      selectable={true}
      selectMirror={true}
      events={events}
      dateClick={handleDateClick}
      eventClick={handleEventClick}
      // select={handleSelect}
      style={{ width: '100%', margin: '0 auto' }}
    />
        
    </Card.Body>
  </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={9} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"69rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif", marginLeft:"15px" }}>
                <h6 style={{marginRight:"auto", float:"left"}}><b>Date:</b> {selectedDate}</h6>
                <div className="d-flex justify-content-center mt-2">
                   
      <Nav tabs>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggleTab('1'); }}
            style={{ backgroundColor: activeTab === '1' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '1' ? 'white' : 'black' }}
          >
            ROOMS
          </NavLink>
        </NavItem>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggleTab('2'); }}
            style={{ backgroundColor: activeTab === '2' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '2' ? 'white' : 'black' }}
          >
            SEATS
          </NavLink>
        </NavItem>
      </Nav>
    </div>
<br/>
<br/>
<br/>
<br/>
<br/>


<TabContent activeTab={activeTab}>
        <TabPane tabId="1" style={{marginTop:"-75px"}}>
    <div className="calendars-container" style={{maxHeight:"450px", overflow:"scroll"}}>
    <Table responsive borderless className="calendar-table">
            <thead>
              <tr>
                {rooms.map(room => (
                  <th key={room.id}>
                    <img
                      src={`${var_api}/${room.room_image}`}
                      alt={room.room_name}
                      style={{ width: '50px', height: '50px', borderRadius: "50px" }}
                    />
                    {" "}{room.room_name}{" "}
                    {/* <span
                      className="badge rounded-pill bg-success"
                      style={{ color: "white", fontWeight: "normal", fontSize: "15px" }}
                      onClick={() => handletoOpenConfirmRoom(room.id, room.room_name)}
                    >
                      <i className="bi bi-plus-circle"></i>{" "}
                    </span> */}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr style={{border:"1px solid black"}}>
                {rooms.map(room => (
                  <td key={room.id}>
                    {room.confirm_orders.length > 0 ? (
                      room.confirm_orders.map((order, index) => (
                        <div key={index} className="d-flex justify-content-center">
                          <Card className="calendar-card" style={{
                            maxWidth: "12rem", height: "auto",
                            borderLeft: `${order.order_status === 0 ? '10px solid lightSkyBlue' : order.order_status === 1 ? '10px solid green' : order.order_status === 2 ? '10px solid purple' : 'none'}`,
                            marginTop: "10px"
                          }}>
                            <Card.Body>
                              <h6 style={{ float: "right" }} onClick={() => handleOpenEyeOrderDetail(order, room.room_name)}>
                                <i className="bi bi-eye-fill" style={{ color: "rgba(103, 120, 95)" }}></i>
                              </h6>
                              <br />
                              <h6><b>Booking No: {order.order_id}</b></h6>
                              <h6 style={{fontSize:"12px"}}><b>Customer: </b>{order.customer_name}</h6>
                              <h6 style={{fontSize:"12px"}}><b>Mobile: </b>{order.customer_mobile}</h6>
                              <p style={{ fontSize: "12px" }}>From-To: <b>  {order.services.length > 0
      ? order.services
          .map(
            (service) =>
              `${service.room_start_time} - ${service.room_end_time || 'N/A'}`
          )
          .join(", ")
      : "N/A"}</b></p>
                              {/* <p style={{ fontSize: "12px" }}>From Time: <b>{order.services[0] && order.services[0].room_start_time}</b><br />
                                <span style={{ fontSize: "12px", lineHeight: "5px" }}>To Time: <b>{order.services.length > 0 ? order.services[order.services.length - 1].room_end_time : 'N/A'}</b></span></p> */}
                                <h6 style={{ float: "center", marginRight: "10px" }}>
                                {/* {
                                    (order.order_status == 0 || order.order_status == 1) && <i className="bi bi-trash-fill" style={{ color: "red" }} onClick={()=>handleOpenDelete(order)}></i>
                                  } */}
                            
                          </h6>
                            </Card.Body>
                          </Card>
                        </div>
                      ))
                    ) : (
                      <div>No Orders</div>
                    )}
                  </td>
                ))}
              </tr>
            </tbody>
          </Table>
        </div>
    
    
        </TabPane>



       <TabPane tabId="2" style={{marginTop:"-75px"}}>
            <div className="calendar-container" style={{maxHeight:"450px"}}>
            <Table responsive  className="calendar-table" >
            <thead>
              <tr>
                {seats.map(seat => (
                  <th key={seat.id}>
                    <img
                      src={`${var_api}/${seat.seat_image}`}
                      alt={seat.seat_name}
                      style={{ width: '50px', height: '50px', borderRadius: "50px" }}
                    />
                    {" "}{seat.seat_name}{" "}
                    {/* <span
                      className="badge rounded-pill bg-success"
                      style={{ color: "white", fontWeight: "normal", fontSize: "15px" }}
                      onClick={() => handletoOpenConfirmSeat(seat.id, seat.seat_name)}
                    >
                      <i className="bi bi-plus-circle"></i>{" "}
                    </span> */}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {seats.map(seat => (
                  <td key={seat.id} style={{border:"1px solid black"}}>
                    {seat.confirm_orders && seat.confirm_orders.length > 0 ? (
                      seat.confirm_orders.map((order, index) => (
                        <div key={index} className="d-flex justify-content-center">
                          <Card className="calendar-card" style={{
                            maxWidth: "12rem", height: "auto",
                            borderLeft: `${order.order_status === 0 ? '10px solid lightSkyBlue' : order.order_status === 1 ? '10px solid green' : order.order_status === 2 ? '10px solid purple' : 'none'}`,
                            marginTop: "10px"
                          }}>
                            <Card.Body>
                              <h6 style={{ float: "right" }} onClick={() => handleOpenEyeOrderDetailseat(order, seat.seat_name)}>
                                <i className="bi bi-eye-fill" style={{ color: "rgba(103, 120, 95)" }}></i>
                              </h6>
                              <br />
                              <h6><b>Booking No: {order.order_id}</b></h6>
                               <h6 style={{fontSize:"12px"}}><b>Customer: </b>{order.customer_name}</h6>
                              <h6 style={{fontSize:"12px"}}><b>Mobile: </b>{order.customer_mobile}</h6>
                              <p style={{ fontSize: "12px" }}>From Time: <b>{order.services[0] && order.services[0].seat_start_time}</b><br />
                                <span style={{ fontSize: "12px", lineHeight: "5px" }}>To Time: <b>{order.services.length > 0 ? order.services[order.services.length - 1].seat_end_time : 'N/A'}</b></span></p>
                                {/* <h6 style={{ float: "center", marginRight: "10px" }}>
                                  {
                                    (order.order_status == 0 || order.order_status == 1) && <i className="bi bi-trash-fill" style={{ color: "red" }} onClick={()=>handleOpenDelete(order)}></i>
                                  }
                          </h6> */}
                            </Card.Body>
                          </Card>
                        </div>
                      ))
                    ) : (
                      <div>No Orders</div>
                    )}
                  </td>
                ))}
              </tr>
            </tbody>
            </Table>
          </div>
          </TabPane>
      </TabContent>

                
      </Card>
                </Col>
            </Row>

            <Modal
        show={isOpen}
        onHide={handleCloseOrderConfirmation}
        backdrop="static"
        keyboard={false}
        size="lg" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{padding:"12px",textAlign:"center", backgroundColor:"rgba(103, 120, 95, 0.367)"}}>
        <Modal.Title style={{fontSize:"19px", fontWeight:"bold",textAlign:"center"}}> Room1   <i class="bi bi-calendar"></i> 26-04-2024 <i class="bi bi-clock"></i> 11:00 AM </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
        <h6 style={{textAlign:"center", fontWeight:"bolder"}}>Booking Details  <span class="badge rounded-pill bg-success" style={{fontWeight:"normal",fontSize:"17px", marginLeft:"20px"}}>Inprogress</span></h6>
        
 
                   <div class="card" style={{ width: "30rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor:"rgba(103, 120, 95, 0.367)",borderRadius:"15px" }} >
                  
                       <div class="card-body">
                       <div className="row">
       <div className="col">
         <h6 style={{color:"rgba(103, 120, 95)"}}>Beautician:{" "}<b style={{color:"black"}}>Kalpana</b> </h6>
       </div>
       <div className="col">
       </div>
     </div>
                        
    
     <div className="row">
       <div className="col">
         <h6 style={{color:"rgba(103, 120, 95)"}}>Customer Name:{" "}<b style={{color:"black"}}>vinoth</b> </h6>
       </div>
       <div className="col">
         <h6 style={{color:"rgba(103, 120, 95)"}}>Mobile: {" "}<b style={{color:"black"}}>9035678765</b></h6>
       </div>
     </div>
    <hr/>
 
 
 
 <div class="card" style={{ width: "20rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor:"white",borderRadius:"15px" }} >
                  
                       <div class="card-body">
    <div className="row align-items-center">
         <div className="col-auto">
           <img src={fruit} alt="Room" style={{ borderRadius: "50%", height: "50px", width: "50px" }} />
         </div>
         <div className="col">
           <span>fruit Facial</span><br />
           <span style={{color:"black",fontWeight:"bolder"}}>12 SGD</span>
         </div>
       </div>
       </div>
       </div>
    
   </div>
  
 </div>
 <br/>
 
 
      
        </Modal.Body>
      </Modal>


      <Modal
        show={isdelete}
        onHide={handleCloseDelete}
        backdrop="static"
        keyboard={false}
        size="lg" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{padding:"12px",textAlign:"center", backgroundColor:"rgba(103, 120, 95, 0.367)"}}>
        <Modal.Title style={{fontSize:"19px", fontWeight:"bold",textAlign:"center"}}> Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
       <div className="p-3">


       <h5>Are You Sure Want to Cancel this  <b style={{color:"red"}}>{deletedOrder && deletedOrder.service_name}</b>  Service ?</h5>

       <Form.Group controlId="formBasicDescription" className="mb-2 single-line-form-group">
    <Form.Label className="form-label"><b>Remarks</b></Form.Label>
    <Form.Control type="text" placeholder="Enter remarks" className="form-control" value={remarks}
          onChange={(e) => setRemarks(e.target.value)}/>
  </Form.Group>
       {
          activeTab == "1"  ?  <button className="btn btn-danger" onClick={handleSubmitRoom}>Confirm</button> :  <button className="btn btn-danger" onClick={handleSubmit}>Confirm</button>
        }
        {/* <h5>Are You Sure Want to Cancel this  {
          activeTab == "1" ?  "room" :  "seat"
        }  Service ?</h5>
       </div>

       <Table responsive borderless className="calendars-table">
            <thead>
              <tr >
                  <th  style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)"}}> <Input
            type="checkbox" checked={allChecked} onChange={handleAllCheck}
            
          />{" "}All</th>
                  <th  style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)"}}>Service</th>
                  <th  style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)"}}>Cost</th>
                  <th  style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)"}}>Time</th>
              </tr>
            </thead>
            <tbody>
              {
                deletedOrder && deletedOrder.services && deletedOrder.services.map((service, index)=>(
                  <tr key={index}>
                  <td style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)"}}><Input type="checkbox"  checked={checkedServices.includes(index)}
                    onChange={() => handleServiceCheck(index)}/></td>
                  <td style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)",textAlign:"left"}}>
                    <img src={`${var_api}/${service.service_image}`} alt="sign" style={{width:"50px", height:"50px", borderRadius:"50px"}} /> {" "}
                   {service.service_name}
                  </td>
                  <td style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)"}}>{service.service_cost}</td>
                  <td style={{border:"none", borderBottom:"2px solid rgba(103,120,95,1)"}}>{service.service_duration}</td>
                </tr>
                ))
              }
                
            </tbody>
        </Table>
        <Form.Group controlId="formBasicDescription" className="mb-2 single-line-form-group">
    <Form.Label className="form-label"><b>Remarks</b></Form.Label>
    <Form.Control type="text" placeholder="Enter remarks" className="form-control" value={remarks}
          onChange={(e) => setRemarks(e.target.value)}/>
  </Form.Group>
        <div className="text-center">
        <button className="btn btn-secondary"style={{marginRight:"5px"}} onClick={handleCloseDelete}>Cancel</button>
        {
          activeTab == "1" ?  <button className="btn btn-danger" onClick={handleSubmitRoom}>Confirm</button> :  <button className="btn btn-danger" onClick={handleSubmit}>Confirm</button>
        }
        */}
        </div>
      
        </Modal.Body>
      </Modal>





      <Modal
        show={isOrderConfirmationseat}
        onHide={handleCloseOrderConfirmationseat}
        backdrop="static"
        keyboard={false}
        size="lg" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{ padding: "12px", textAlign: "center", backgroundColor: "rgba(103, 120, 95, 0.367)" }}>
          <Modal.Title style={{ fontSize: "19px", fontWeight: "bold", textAlign: "center" }}>
            {selectedRoomNameseat} <i className="bi bi-calendar"></i> {startDate}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 style={{ textAlign: "center", fontWeight: "bolder" }}>
            Booking Details
            <span className="badge rounded-pill" style={{ fontWeight: "normal", fontSize: "18px", marginLeft: "20px" }}>
              {viewServiceseat && viewServiceseat.order_status === 0 ? (
                <span className="badge rounded-pill" style={{ backgroundColor: "lightSkyBlue", color: "white", fontWeight: "normal", fontSize: "15px" }}>Upcoming</span>
              ) : viewServiceseat && viewServiceseat.order_status === 1 ? (
                <span className="badge rounded-pill" style={{ backgroundColor: "green", color: "white", fontWeight: "normal", fontSize: "15px" }}>In Progress</span>
              ) : viewServiceseat && viewServiceseat.order_status === 2 ? (
                <span className="badge rounded-pill" style={{ backgroundColor: "purple", color: "white", fontWeight: "normal", fontSize: "15px" }}>Completed</span>
              ) : null}
            </span>
          </h6>

          {/* {
            (viewServiceseat && viewServiceseat.order_status == 0 || viewServiceseat && viewServiceseat.order_status == 1) && <button className="btn btn-success"><i class="bi bi-plus-circle"></i> Add</button>
          } */}

          {viewServiceseat && viewServiceseat.services && viewServiceseat.services.map((order, index) => (
            <div key={index}>
              <div className="card" style={{ width: "30rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor: "rgba(103, 120, 95, 0.367)", borderRadius: "15px" }}>
                <div className="card-body">
                {(viewServiceseat.order_status == 0 || viewServiceseat.order_status == 1) && 
                <>
                 <i className="bi bi-trash-fill" style={{ color: "red", float:"right" }} onClick={()=>handleOpenDelete(order)}></i>
                <i className="bi bi-pencil-square" style={{ color: "blue", fontSize: "18px", float:"right" }} onClick={() => handleOpenOrderEdit(order)}></i>
                </>
               }

                  <div className="row">
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>Beautician:{" "}<b style={{ color: "black" }}>{order.employee_name}</b></h6>
                    </div>
                    <div className="col"></div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>Customer Name:{" "}<b style={{ color: "black" }}>{viewServiceseat.customer_name}</b></h6>
                    </div>
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>Mobile: {" "}<b style={{ color: "black" }}>{viewServiceseat.customer_mobile}</b></h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>From Time:{" "}<b style={{ color: "black" }}>{order.seat_start_time}</b></h6>
                    </div>
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>To Time:{" "}<b style={{ color: "black" }}>{order.seat_end_time}</b></h6>
                    </div>
                  </div>
                  <hr />
                  <div className="card" style={{ width: "20rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor: "white", borderRadius: "15px" }}>
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <img src={`${var_api}/${order.service_image}`} alt="Room" style={{ borderRadius: "50%", height: "50px", width: "50px" }} />
                        </div>
                        <div className="col">
                          <span>{order.service_name}</span><br />
                          <span style={{ color: "black", fontWeight: "bolder" }}>{order.service_cost + order.additional_cost} $</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          ))}
        </Modal.Body>
      </Modal>

      <Modal
        show={isOrderConfirmation}
        onHide={handleCloseOrderConfirmation}
        backdrop="static"
        keyboard={false}
        size="lg" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{ padding: "12px", textAlign: "center", backgroundColor: "rgba(103, 120, 95, 0.367)" }}>
          <Modal.Title style={{ fontSize: "19px", fontWeight: "bold", textAlign: "center" }}>
            {selectedRoomName} <i className="bi bi-calendar"></i> {startDate}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 style={{ textAlign: "center", fontWeight: "bolder" }}>
            Booking Details
            <span className="badge rounded-pill" style={{ fontWeight: "normal", fontSize: "18px", marginLeft: "20px" }}>
              {viewService && viewService.order_status === 0 ? (
                <span className="badge rounded-pill" style={{ backgroundColor: "lightSkyBlue", color: "white", fontWeight: "normal", fontSize: "15px" }}>Upcoming</span>
              ) : viewService && viewService.order_status === 1 ? (
                <span className="badge rounded-pill" style={{ backgroundColor: "green", color: "white", fontWeight: "normal", fontSize: "15px" }}>In Progress</span>
              ) : viewService && viewService.order_status === 2 ? (
                <span className="badge rounded-pill" style={{ backgroundColor: "purple", color: "white", fontWeight: "normal", fontSize: "15px" }}>Completed</span>
              ) : null}
            </span>
          </h6>

          {viewService && viewService.services && viewService.services.map((order, index) => (
            <div key={index}>
              <div className="card" style={{ width: "30rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor: "rgba(103, 120, 95, 0.367)", borderRadius: "15px" }}>
                <div className="card-body">
                {
                                    (viewService.order_status == 0 || viewService.order_status == 1) && <h6>
                                      <i className="bi bi-trash-fill" style={{ color: "red", float:"right" }} onClick={()=>handleOpenDelete(order)}></i>
                                      <i className="bi bi-pencil-square" style={{ color: "blue", fontSize: "18px", float:"right" }} onClick={() => handleOpenOrderEdit(order)}></i>
                                    </h6>
                                  }
                  <div className="row">
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>Beautician:{" "}<b style={{ color: "black" }}>{order.employee_name}</b></h6>
                    </div>
                    <div className="col"></div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>Customer Name:{" "}<b style={{ color: "black" }}>{viewService.customer_name}</b></h6>
                    </div>
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>Mobile: {" "}<b style={{ color: "black" }}>{viewService.customer_mobile}</b></h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>From Time:{" "}<b style={{ color: "black" }}>{order.room_start_time}</b></h6>
                    </div>
                    <div className="col">
                      <h6 style={{ color: "rgba(103, 120, 95)" }}>To Time:{" "}<b style={{ color: "black" }}>{order.room_end_time}</b></h6>
                    </div>
                  </div>
                  <hr />
                  <div className="card" style={{ width: "20rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor: "white", borderRadius: "15px" }}>
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <img src={`${var_api}/${order.service_image}`} alt="Room" style={{ borderRadius: "50%", height: "50px", width: "50px" }} />
                        </div>
                        <div className="col">
                          <span>{order.service_name}</span><br />
                          <span style={{ color: "black", fontWeight: "bolder" }}>{order.service_cost + order.additional_cost} $</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          ))}
        </Modal.Body>
      </Modal>


      <Modal
        show={isOpenOrderEdit}
        onHide={handleCloseOrderEdit}
        backdrop="static"
        keyboard={false}
        size="lg" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ padding: "10px" }}></div>
          <div className="card" style={{ maxWidth: "35rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "10px", height: "auto", borderRadius: "15px" }}>
            <div className="card-body">
              {/* <div className="row">
                <div className="col">
                  <h6 style={{ color: "rgba(103, 120, 95)" }}>Booked By:{" "}<b style={{ color: "black" }}>{order.customer_name}</b> </h6>
                </div>
                <div className="col">
                  <h6 style={{ color: "rgba(103, 120, 95)" }}>Mobile: {" "}<b style={{ color: "black" }}>{order.customer_mobile}</b></h6>
                </div>
              </div> */}
              <hr />
              <div className="d-flex justify-content-center">
                <Accordion>
                  <Accordion.Item eventKey="0" style={{ border: "none" }}>
                    <Accordion.Header>
                      <div className="card" style={{ width: "21rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor: "rgba(103, 120, 95, 0.367)", borderRadius: "15px", margin: "8px" }}>
                        {updateOrder && (
                          <div className="card-body">
                            <div className="row align-items-center">
                              <div className="col">
                                <span>{updateOrder.service_name} <span style={{ float: "right", fontSize: "18px", color: "rgba(103, 120, 95)" }}></span></span>
                                {/* <span style={{ color: "black", fontWeight: "bolder" }}>{additionalCheckedUpdate ? updateOrder.service_cost + additionalCostUpdate : updateOrder.service_cost} $</span> */}
                                <span style={{ color: "black", fontWeight: "bolder" }}>{updateOrder.service_cost + additionalCostUpdate } $</span>
                              </div>
                            </div>
                            <hr />
                            <h6 style={{ fontSize: "13px" }}><b>Duration:</b>    
                            {/* {additionalCheckedUpdate
                              ? convertMinutesToHours(
                                  parseInt(updateOrder.service_duration, 10) + parseInt(additionalDurationUpdate, 10)
                                )
                              : convertMinutesToHours(parseInt(updateOrder.service_duration, 10))}{' '} */}
                                { convertMinutesToHours(
                                  parseInt(updateOrder.service_duration, 10) + parseInt(additionalDurationUpdate, 10)
                                )
                            }{' '}
                           <span style={{ fontSize: "13px", float: "right" }}><b>Beautician:</b> {updateOrder.employee_name} </span></h6>
                            {
                              activeTab === '1' ? (<h6 style={{ fontSize: "13px" }}><b> From Time:</b> {updateOrder && updateOrder.room_start_time ? formatTimeTo12Hours(updateOrder.room_start_time) : "-"} <span style={{ fontSize: "13px", float: "right" }}><b> To Time:</b> {updateOrder && updateOrder.room_end_time ? formatTimeTo12Hours(updateOrder.room_end_time) : "-"} </span></h6>) 
                              : (<h6 style={{ fontSize: "13px" }}><b> From Time:</b> {updateOrder && updateOrder.seat_start_time ? formatTimeTo12Hours(updateOrder.seat_start_time) : "-"} <span style={{ fontSize: "13px", float: "right" }}><b> To Time:</b> {updateOrder && updateOrder.seat_end_time ? formatTimeTo12Hours(updateOrder.seat_end_time) : "-"} </span></h6>)
                            }

<Form>
     <div key="checkbox" className="d-flex align-items-center justify-content-between">
     <div className="d-flex align-items-center">
     <Form.Check
        type="checkbox"
        id="check-api-checkbox-additional-update"
        checked={additionalCheckedUpdate}
        onChange={handleAdditionalCheckboxChangeUpdate}
      />{" "}
                        <Form.Check.Label htmlFor="check-api-checkbox-additional-update" style={{ fontSize: "13px", fontWeight:"bolder", marginLeft:"5px" }}>
                          Additional
                        </Form.Check.Label>
                        </div>
                      </div>
                    </Form>
                    {additionalCheckedUpdate && (
    <div>
      <Form.Group controlId="additional-cost-update" className="mt-1">
        <Form.Label style={{ fontSize: "12px", fontWeight: "bold" }}>Additional Cost</Form.Label>
        <Form.Control
          type="number"
          placeholder="Enter additional cost"
          value={additionalCostUpdate}
          onChange={handleAdditionalCostChangeUpdate}
          min="0.1"
          step="0.1"
        />
      </Form.Group>
      <Form.Group controlId="additional-duration-update" className="mt-1">
        <Form.Label style={{ fontSize: "12px", fontWeight: "bold" }}>Additional Duration (in mins)</Form.Label>
        <Form.Control
          type="number"
          placeholder="Enter additional duration (minutes)"
          value={additionalDurationUpdate}
          onChange={handleAdditionalDurationChangeUpdate}
          min="0.1"
          step="0.1"
        />
      </Form.Group>
    </div>
  )}

                            
                          </div>
                        )}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div style={{ display: 'flex', alignItems: 'center', gap: "10px", margin: "auto" }}>
                        <div>
                          <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>From Time: </label>
                          {
                            activeTab === "1" ? (
                              <input
                            type="time"
                            name="room_start_time"
                            placeholder="select time"
                            value={updateOrder && updateOrder.room_start_time ? updateOrder.room_start_time : ""}
                            onChange={handleTimeChangeUpdateRoom}
                          />
                            ) : (
                              <input
                            type="time"
                            name="seat_start_time"
                            placeholder="select time"
                            value={updateOrder && updateOrder.seat_start_time ? updateOrder.seat_start_time : ""}
                            onChange={handleTimeChangeUpdateSeat}
                          />
                            )
                          }
                          
                        </div>
                        <div>
                          <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>To Time: </label>
                          <span>{activeTab === "1" ? updateOrder && formatTimeTo12Hours(updateOrder.room_end_time) : updateOrder && formatTimeTo12Hours(updateOrder.seat_end_time)}</span>
                        </div>
                        <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>Beautician: </label>
                        <Select
                            options={beauticians}
                            value={{label:updateOrder && updateOrder.employee_name, value: updateOrder && updateOrder.employee_id}}
                            onChange={handleBeauticianChangeUpdate}
                            placeholder="Select Beautician"
                            isSearchable={true}
                            menuPlacement="bottom"
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                position: 'absolute',
                              }),
                              container: (provided) => ({
                                ...provided,
                                width: '30%',
                              }),
                              control: (provided) => ({
                                ...provided,
                              }),
                            }}
                          />
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <br />
              <br />
              <div className="text-center">
                <button className="btn btn-success" style={{ color: "white", backgroundColor: "rgba(103, 120, 95)", borderColor: "rgba(103, 120, 95)", fontWeight: "normal" }} onClick={ activeTab === '2' ? handleSubmitUpdate : handleSubmitUpdateroom}>Update</button>
                <br />
                <br />
              </div>
            </div>
          </div>
          <br />
          <button className="btn btn-danger" style={{ fontWeight: "normal", float: "right" }} onClick={handleCloseOrderEdit}>Close</button>{' '}
          
        </Modal.Body>
      </Modal>
        </div>
        </>
    )
}


export default RoomSeatStatus;
